var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animation"},[_c('img',{staticClass:"background-image",attrs:{"src":require("../../../assets/images/main/animation-images/scan-report-1.svg"),"alt":"scan-report"}}),_c('img',{staticClass:"top-image",attrs:{"src":require("../../../assets/images/main/animation-images/high-severity.png"),"alt":"high-severity"}})])
}]

export { render, staticRenderFns }